/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    function boxmanInit() {
        if (!document.body.classList.contains('admin')) {
            return;
        }
        $("#dialog").on("dialogopen", function () {
            tryUntilReady(function () {
                var boxForm = document.getElementById('moyaextension\\carousel\\form');
                return !!boxForm;
            }, function () {
                initForm(document.getElementById('moyaextension\\carousel\\form'));
            });
        });
    }
    function tryUntilReady(isReady, success, error, count, interval) {
        if (!count) {
            count = 100;
        }
        if (!interval) {
            interval = 20;
        }
        if (isReady()) {
            success();
            return;
        }
        // The call back isn't ready. We need to wait for it
        setTimeout(function () {
            if (!count) {
                // We have run out of retries
                if (error) {
                    error();
                }
            }
            else {
                // Try again
                tryUntilReady(isReady, success, error, count - 1, interval);
            }
        }, interval);
    }
    function initForm(boxForm) {
        function hideLabels() {
            var hiddenElms = boxForm.querySelectorAll('.hidden');
            hiddenElms.forEach(function (elm) {
                var id = elm.id;
                if (id) {
                    var label = document.querySelector("label[for='" + id + "']");
                    label.classList.add('hidden');
                    label.setAttribute('data-viewmodel', elm.getAttribute('data-viewmodel'));
                    label.setAttribute('has-datasrc', '');
                }
            });
        }
        function toggleElemntsByViewModelSrc() {
            var nameSpaceSelect = boxForm.querySelector('#namespace');
            util.delegate(nameSpaceSelect, 'change', '#namespace', function (e) {
                e.preventDefault();
                boxForm.querySelectorAll('[has-datasrc]').forEach(function (elm) {
                    elm.classList.add('hidden');
                });
                if (e.target instanceof HTMLSelectElement) {
                    boxForm.querySelectorAll('[data-viewmodel="' + e.target.value + '"]').forEach(function (elm) {
                        elm.classList.remove('hidden');
                    });
                }
            });
        }
        function showSelected() {
            var nameSpaceSelect = boxForm.querySelector('#namespace');
            if (nameSpaceSelect.value) {
                boxForm.querySelectorAll('[data-viewmodel="' + nameSpaceSelect.value + '"]').forEach(function (elm) {
                    elm.classList.remove('hidden');
                });
            }
        }
        hideLabels();
        showSelected();
        toggleElemntsByViewModelSrc();
    }
    boxmanInit();

}());
typeof tsBuild === 'function' && tsBuild();})();
